import VueRouter from 'vue-router';

let routes = [
    /*{
        path: '/',
        component: require('./components/views/Home').default
    },*/
    /*{
        path: '/:language',
        component: require('./components/views/Home').default
    },*/
/*    {
        path: '/en',
        component: require('./components/views/Home').default
    },*/
    /*{
        path: '/authenticate',
        component: require('./components/views/Login').default
    },*/
/*    {
        path: '/test',
        component: require('./components/views/Test').default
    },*/
    {
        path: '/:language/login',
        component: require('./components/views/Login').default
    },
    {
        path: '/:language/register',
        component: require('./components/views/Login').default
    },
    {
        path: '*',
        component: require('./components/views/NotFound').default
    }
];

export default new VueRouter ({
    mode: 'history',
    routes,
    linkActiveClass: 'vue-active-link'
});
